<template>
  <g>
    <path
      d="M3.65196 14.3039L28.4535 14.3039L23.0299 19.7275C22.2955 20.4619 22.2955 21.6483 23.0299 22.3828C23.7644 23.1172 24.9508 23.1172 25.6852 22.3828L34.3291 13.7389C35.0635 13.0045 35.0635 11.8181 34.3291 11.0836L25.6852 2.43983C24.9508 1.70539 23.7644 1.70539 23.0299 2.43983C22.2955 3.17427 22.2955 4.36067 23.0299 5.09512L28.4535 10.5375L3.65196 10.5375C2.61621 10.5375 1.76877 11.385 1.76877 12.4207C1.76877 13.4565 2.61621 14.3039 3.65196 14.3039Z"
      :fill="iconColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M25.1226 15.6838L3.65172 15.6838C1.85402 15.6838 0.388909 14.2187 0.388909 12.421C0.38891 10.6233 1.85402 9.15814 3.65172 9.15814L25.1307 9.15815L22.0542 6.07092C22.0537 6.07046 22.0532 6.07 22.0528 6.06954C20.7809 4.79622 20.7814 2.7373 22.0542 1.46454C23.3274 0.191314 25.3873 0.191314 26.6605 1.46454L35.3044 10.1084C36.5776 11.3816 36.5776 13.4415 35.3044 14.7147L26.6605 23.3586C25.3873 24.6318 23.3274 24.6318 22.0542 23.3586C20.7809 22.0853 20.7809 20.0254 22.0542 18.7522L25.1226 15.6838ZM28.4533 14.3041L23.0297 19.7277C22.2953 20.4622 22.2953 21.6486 23.0297 22.383C23.7641 23.1175 24.9506 23.1175 25.685 22.383L34.3288 13.7392C35.0633 13.0048 35.0633 11.8183 34.3288 11.0839L25.685 2.44008C24.9506 1.70564 23.7641 1.70564 23.0297 2.44008C22.2953 3.17452 22.2953 4.36093 23.0297 5.09537L28.4533 10.5378L3.65172 10.5378C2.61597 10.5378 1.76854 11.3852 1.76854 12.421C1.76854 13.4567 2.61597 14.3041 3.65172 14.3041L28.4533 14.3041Z"
      :fill="borderColor"
    />
  </g>
</template>

<script>
export default {
  props: {
    iconColor: {
      type: String,
      default: "#ee1c25"
    },

    borderColor: {
      type: String,
      default: "#ffffff"
    }
  }
};
</script>
